module.exports = __webpack_public_path__ + "img/turnOff-icon.65677739.svg";